import CustomModal from 'components/global/CustomModal'
import useFormSubmit from 'helper/Hooks/formSubmit'
import React from 'react'
import { leagueEventStore } from 'state/league/leagueEvent'
import RoundForm from './ContentForm/RoundForm'
import CustomModalFooter from 'components/global/CustomModalFooter'

const RoundModal = () => {
  const { handleSubmit, form } = useFormSubmit()
  const { roundsModal, setRoundsModal } = leagueEventStore(store => ({
    roundsModal: store.roundsModal,
    setRoundsModal: store.setRoundsModal,
  }))

  const handleClose = () => {
    setRoundsModal(false)
  }

  return (
    <>
      <CustomModal
        openModal={roundsModal}
        isCloseModalCustom={true}
        closeModal={handleClose}
        title="Rounds"
        width={600}
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText="Save"
            btnType="primary"
            onSubmit={handleSubmit}
          />
        }
      >
        <RoundForm form={form} />
      </CustomModal>
    </>
  )
}

export default RoundModal
